import styled, { css } from 'styled-components';

import { IconButton } from 'ui/button';
import { CollapsibleContent } from 'ui/collapsibleContent';
import { TagGroup } from 'ui/tags';
import { caption, colors, fontWeights, spacing } from 'ui/theme';
import { Link } from 'ui/links';
import { SearchParamLink } from 'ui/utility/SearchParamLink/SearchParamLink';
import { pxToRem } from 'utils/convert';

import { PAGE_SEARCH_PARAM, PARENT_CAMPAIGN_ID_SEARCH_PARAM } from '../constants';

export const PREVIEW_WIDTH = 60;

export const HorizontalFlex = styled.div`
  display: flex;
  align-items: center;
`;

export const CollapsibleNameCell = styled(HorizontalFlex)`
  justify-content: space-between;
  max-width: 100%;
`;

export const Content = styled.div`
  align-items: flex-start;
  display: inline-flex;
  flex: 1 0 auto;
  flex-direction: column;
  /** width minus 48px for arrow button and 8px for margin */
  max-width: calc(100% - ${pxToRem(56)});
`;

const NameStyles = css`
  color: ${colors.textPrimary};
  margin-bottom: ${spacing.quarter};
  overflow-wrap: anywhere;
  font-weight: 400;
  text-decoration-color: transparent;
`;

export const NameLink = styled(Link)`
  ${NameStyles}
`;

const StyledSearchParamLink = styled(SearchParamLink)`
  ${NameStyles}
`;

export const RecurringCampaignLink = ({ id, name }: { id: number; name: string }) => (
  <StyledSearchParamLink
    searchParams={{
      [PARENT_CAMPAIGN_ID_SEARCH_PARAM]: id.toString(),
    }}
    deleteSearchParams={[PAGE_SEARCH_PARAM]}
  >
    {name}
  </StyledSearchParamLink>
);

export const Details = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  // gets rid of weird padding inside of tooltips
  [data-test='tooltip-trigger'] {
    border: none;
    padding: 0;
  }

  [data-test='tag-group-content-wrapper'] {
    display: inline-flex;
    flex-wrap: wrap;

    // remove extra space to the left of first tag since the bullet
    // separator to its left already provides it
    > :first-child {
      margin-left: 0;
    }
  }

  // generate bullet separators
  > * + * {
    :before {
      color: ${colors.grey35};
      content: '\\2219'; /** unicode for bullet operators */
      margin-right: ${spacing.quarter};
      font-weight: ${fontWeights.semiBold};
    }
    margin-left: ${spacing.quarter};
  }
`;

export const PrimaryCaption = styled.span`
  ${caption}
  color: ${colors.textPrimary};
`;

export const SecondaryCaption = styled(PrimaryCaption)`
  color: ${colors.textSecondary};
`;

export const StyledTagGroup = styled(TagGroup)`
  display: inline;
`;

export const IconWrapper = styled.div`
  display: inline-flex;
  /** this aligns the svgs */
  vertical-align: sub;
`;

export const StyledCollapsibleContent = styled(CollapsibleContent)`
  grid-column: 3 / span 1;
  grid-row: 2 / span 1;
`;

export const CollapsibleItem = styled.div`
  ${caption}
  color: ${colors.textPrimary};
  display: grid;
  grid-template-columns: ${pxToRem(108)} auto;
`;

export const ArrowButton = styled(IconButton)`
  cursor: pointer;
  flex: 0 0 auto;
  margin-right: ${spacing.quarter};
`;

export const CampaignIcons = styled.span`
  > * + * {
    margin-left: ${spacing.quarter};
  }
`;
